export default __webpack_public_path__ + "static/media/gettingStarted.999b2a25.png";